{
  "amazonSalesBanner": {
    "period": "",
    "title": ""
  },
  "easeOfUse": {
    "description": "Just scan the QR code to connect your frame to FamilyAlbum.\nNew photos and videos appear automatically, so your family can enjoy fresh memories every day.\nWi-Fi is required.",
    "title": "Easy Setup\nMemories Start Arriving Automatically",
    "videoHeading": "Set it up in minutes, and\nwatch your memories flow in.",
    "videoTitle": "Set it up in minutes, and watch your memories flow in."
  },
  "emotionalClosing": {
    "paragraphs": "Turn everyday family moments into something everyone can enjoy.\n\nFamilyAlbum Digital Frame keeps new memories flowing\nfrom your family's albums to the places you gather.\n\nA simple way to stay connected with the people you love."
  },
  "faq": {
    "giftAnswer": {
      "description": "There are two ways to link an account.",
      "intro": "Yes.",
      "recipientBody": "If the recipient already has a FamilyAlbum account, they can link the frame themselves. The frame will show the photos and videos that are visible to that account.",
      "recipientTitle": "Linking with the recipient's account",
      "senderBody": "If the recipient does not have a FamilyAlbum account, the sender can set up the frame first and then gift it. In this case, the frame can show the photos and videos visible to the sender's account. Wi-Fi is required wherever the frame will be used.",
      "senderTitle": "Linking with the sender's account"
    },
    "heading": "FAQ",
    "items": [
      {
        "answer": "Yes. A Wi-Fi connection is required to receive photos and videos.",
        "question": "Do I need a Wi-Fi connection?"
      },
      {
        "answer": "Yes. Videos with sound can be played. Video playback requires a FamilyAlbum Premium subscription. Volume can be adjusted from the settings screen. Fast-forward is not supported.",
        "question": "Can I watch videos? Does it play sound?"
      },
      {
        "answer": "No. You can use the frame by purchasing the device. Without FamilyAlbum Premium, the frame displays 11 recommended photos from FamilyAlbum each month. Videos, more than 11 photos, and manual photo selection require Premium.",
        "question": "Do I need a subscription in addition to buying the device?"
      },
      {
        "answer": "Yes. Premium benefits apply by album, so anyone participating in an album with Premium can use Premium features. For example, grandparents who are members of a Premium album can link their own account to the frame and use Premium features.",
        "question": "If I subscribe to Premium, can other family members in the album use Premium features?"
      },
      {
        "answer": "Premium benefits such as unlimited photo display will no longer be available. The frame will display 11 recommended photos from FamilyAlbum each month. Videos, more than 11 photos, and manual photo selection will not be available.",
        "question": "What happens if I cancel FamilyAlbum Premium?"
      },
      {
        "answer": "Yes. You can hang the frame using the holes on the back and separately prepared screws, or place it on a desk or shelf with the included stand. The frame must remain plugged in while in use.",
        "question": "Can it be wall-mounted?"
      },
      {
        "answer": "",
        "question": "Can I gift it to grandparents or family who live far away?",
        "type": "gift"
      },
      {
        "answer": "During setup, you can choose which albums to display. This lets the frame show photos and videos from multiple albums without switching albums manually. Premium benefits only apply to albums with Premium.",
        "question": "How does it work if I participate in multiple FamilyAlbum albums?"
      },
      {
        "answer": "No. Although the frame has ports, external devices such as USB memory drives are not supported.",
        "question": "Can I use external devices such as USB memory?"
      },
      {
        "answer": "No. The frame does not have a built-in battery and must remain connected to power while in use.",
        "question": "Can I use it without a power cord?"
      },
      {
        "answer": "Yes. Portrait photos can be displayed in either a centered single-photo mode or a two-photo side-by-side mode.",
        "question": "Can it display portrait photos?"
      },
      {
        "answer": "No. If the frame is placed vertically, photos will still be displayed horizontally.",
        "question": "Can I place the frame vertically?"
      },
      {
        "answer": "Yes. Warm gray is currently the only available color.",
        "question": "Is warm gray the only color?"
      }
    ]
  },
  "footer": {
    "manualLink": "Online User Manual",
    "manualUrl": "https://family-album.com/digital_photo_frame/manual"
  },
  "hero": {
    "features": [
      {
        "description": "Just plug in and scan a QR code to connect\nyour FamilyAlbum account. Your frame is ready\nin minutes: no hassle, just instant joy.",
        "note": "*Requires Wi-Fi to use",
        "title": "Easy Setup"
      },
      {
        "description": "If you participate in multiple albums, you can choose which albums to display and enjoy photos and videos together in one slideshow.\nAll photos and videos are available for albums with Premium.",
        "title": "Photos and Videos from Multiple Albums\nAll in One Frame"
      },
      {
        "description": "Share countless memories from FamilyAlbum\neffortlessly, so your loved ones never miss a\nmoment of your child's story.",
        "title": "Stay Connected"
      }
    ],
    "heading": "Why You'll Love It",
    "lowStockRibbonAlt": "Low stock",
    "highlights": [
      {
        "description": "Use your phone to manage your digital frame with ease. Connect your FamilyAlbum account to your loved ones' frame & support them from anywhere.",
        "title": "Smartphone Remote Control"
      },
      {
        "description": "New media in your albums will automatically appear on your photo frame. Use our smart filters to choose exactly what you want to display.",
        "title": "Automatic Updates"
      },
      {
        "description": "Display memories from multiple albums on your frame for a seamless, all-in-one view of your family's favorite moments.",
        "title": "Display Multiple Albums"
      }
    ],
    "intro": "Your FamilyAlbum memories,\nbeautifully displayed.\nFill your home with the joy of your\nchild's little wonders.",
    "postPurchaseFeature": {
      "description": "Perfect for family who live far away. Set it up with your own FamilyAlbum account before gifting, or let the recipient connect their own account.\nNew photos and videos added to FamilyAlbum can appear automatically.\nWi-Fi is required.",
      "title": "Share Memories with Family"
    },
    "postPurchaseTitle": "Your Memories,\nBeautifully Displayed"
  },
  "memories": {
    "body": "Share countless memories from FamilyAlbum\neffortlessly, so your loved ones never miss a\nmoment of your child's story.",
    "title": "Stay Connected"
  },
  "postPurchase": {
    "thankYou": "Thank you for your purchase!"
  },
  "pricing": {
    "comparison": {
      "freeColumn": "Free",
      "heading": "Compare Features & Plans",
      "note": "Some users with exceptionally large photo or video libraries may be subject to limits.",
      "premiumColumn": "Premium",
      "rows": {
        "filtering": {
          "name": "Display\nFilters",
          "premium": "Favorites\nTime range\nShare Groups"
        },
        "mediaCount": {
          "free": "11 photos,\ncurated monthly",
          "name": "Number of photos\n& videos displayed",
          "premium": "Unlimited*"
        },
        "multipleAlbums": {
          "name": "Multiple Albums"
        },
        "price": {
          "free": "Free",
          "name": "Price\n(tax included)",
          "premium": "$5.99/month"
        },
        "remoteSettings": {
          "name": "Remote control\nfrom the\nFamilyAlbum app"
        },
        "video": {
          "name": "Video Display"
        }
      }
    },
    "freeUser": {
      "bodyLead": "Purchase a FamilyAlbum Digital Frame & enjoy a curated selection of your photos that changes each month.",
      "bodySub": "Upgrade to FamilyAlbum Premium or Pro for complete control over unlimited photos and videos on your frame."
    },
    "heading": "Pricing",
    "premiumUpsell": {
      "bodyLead": "Display all of your FamilyAlbum photos and videos and unlock the frame's full feature set.",
      "bodySub": "Premium also includes other useful and fun features in the FamilyAlbum app.",
      "button": "Learn More About Premium",
      "heading": "Sign up for FamilyAlbum\nPremium to unlock all features",
      "priceAmount": "$5.99",
      "pricePrefix": "From",
      "priceSuffix": "/ month",
      "title": "FamilyAlbum Premium"
    },
    "premiumUser": {
      "badge": "You are subscribed to Premium\nAll features are available!",
      "bodyLead": "Just buy the frame to display all photos and videos without limits.",
      "note": "If you cancel Premium or Pro, the frame will display 11 recommended photos from FamilyAlbum each month."
    },
    "product": {
      "packageContent": "Frame / power cable / support stand / quick start guide",
      "packageLabel": "Package includes:",
      "price": "$154",
      "title": "FamilyAlbum Digital Frame"
    }
  },
  "purchaseButtons": {
    "amazonLabel": "Buy Now",
    "amazonSaleText": "",
    "amazonStoreLabel": "Visit Our Amazon Store",
    "amazonUrl": "https://www.amazon.com/dp/B0FZDHS944",
    "rakutenLabel": "Buy on Rakuten",
    "rakutenUrl": "https://item.rakuten.co.jp/mixiofficial/mdp01-j/",
    "soldOutText": "Sold out"
  },
  "purchaseSteps": {
    "amazonSaleText": "",
    "heading": "From Purchase to Use\nIn 3 Simple Steps",
    "premiumFeatures": "Year-in-review 1s movies\nVideos longer than 2 minutes\nAd-free app experience",
    "premiumFeaturesTitle": "Popular Premium Features",
    "steps": [
      {
        "badge": "Step 1",
        "description": "The FamilyAlbum Digital Frame is available for purchase on Amazon.",
        "title": "Purchase the Main Unit"
      },
      {
        "badge": "Step 2",
        "description": "Plug in, connect to Wi-Fi, and scan the QR code to link your frame with FamilyAlbum.",
        "title": "Scan the QR code\nto connect with FamilyAlbum"
      },
      {
        "badge": "Step 3",
        "description": "Use your photo frame without limits, and unlock even more fun and convenient features in the FamilyAlbum app.",
        "title": "Sign up for FamilyAlbum Premium\nand enjoy unlimited access!\n(Optional)"
      }
    ]
  },
  "soldOut": {
    "noticeBodyAfterBold": ".",
    "noticeBodyBeforeBold": "Our Digital Frame flew off the shelves, but don’t worry, we’ll let you know as soon as it’s ",
    "noticeBodyBold": "back in stock",
    "noticeLogoAlt": "Back Soon",
    "noticeTitle": "Glad We Caught Your Eye!",
    "sticky": "Sold out"
  },
  "usageScenes": {
    "heading": "Share & Cherish Moments",
    "scenes": [
      {
        "description": "For those who aren't tech savvy, the FamilyAlbum Digital frame can be a life changing way to stay connected without using a smartphone.",
        "title": "Share & Cherish Moments"
      },
      {
        "description": "A thoughtful gift for grandparents or family who live far away.\nSet it up with your FamilyAlbum account before gifting, or let the recipient connect their own account.\nNew photos and videos added to FamilyAlbum can appear automatically.\nWi-Fi is required.",
        "title": "For Gifting"
      }
    ]
  },
  "userVoices": {
    "description": "Families are finding new ways to enjoy their memories with the Digital Frame.\nHere are a few moments it helped create.",
    "eyebrow": "User Stories",
    "heading": "Moments Families Love",
    "voices": [
      {
        "author": "K.M.",
        "body": "Our kids naturally gather around the frame before bed. Looking back at memories together has become part of our day.",
        "title": "A daily family favorite"
      },
      {
        "author": "R.T.",
        "body": "We love seeing videos we had almost forgotten about. Our child points at the screen and talks excitedly.",
        "title": "Videos feel special again"
      },
      {
        "author": "H.K.",
        "body": "Our daughter talks about her friends while looking at photos from preschool. It starts so many conversations.",
        "title": "It brings out stories"
      },
      {
        "author": "M.H.",
        "body": "Photos from multiple albums appear together, which creates a new way to enjoy our extended family's memories.",
        "title": "A new way to connect"
      },
      {
        "author": "A.N.",
        "body": "Old photos appear unexpectedly and remind us of moments we had not looked back on in a while.",
        "title": "Unexpected discoveries"
      },
      {
        "author": "J.O.",
        "body": "Photos we usually see on a phone look big and beautiful on the frame.",
        "title": "FamilyAlbum photos shine"
      }
    ]
  }
}
